<div class="palantir-dropdown-menu">
  <button
    type="button"
    class="palantir-dropdown-menu__button"
    icon="arrow-drop-down-outline"
    (cdkMenuOpened)="onMenuOpenChange(true)"
    (cdkMenuClosed)="onMenuOpenChange(false)"
    [cdkMenuTriggerFor]="menu"
    aria-haspopup="true"
    [attr.aria-expanded]="isMenuOpen()"
    aria-label="Dropdown menu"
  >
    {{ valueLabel() }}
    <palantir-icon
      class="palantir-dropdown-menu__icon"
      [ngClass]="{ 'palantir-dropdown-menu__icon--open': isMenuOpen() }"
      name="arrow-drop-down-outline"
    />
  </button>

  <ng-template #menu>
    <palantir-content
      class="palantir-menu palantir-dropdown-menu__menu palantir-scrollbar"
      cdkMenu
      role="menu"
    >
      @for (option of element.options; track option.value) {
        <button
          type="button"
          class="palantir-dropdown-menu__button palantir-dropdown-menu__item"
          (click)="selectOption(option.value)"
          role="menuitem"
          cdkMenuItem
        >
          <div class="palantir-dropdown-menu__item__title">
            <palantir-text type="title">{{ option.label }}</palantir-text>
            @if (option.value === selectedOption()) {
              <palantir-icon class="palantir-dropdown-menu__item__icon" name="check-outline" />
            }
          </div>
          <palantir-text type="description">{{ option.description }}</palantir-text>
        </button>
      }
    </palantir-content>
  </ng-template>
</div>
